/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SelectInput from "./SelectInput";

class TimezonePicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			values: [],
		};
	}

	render() {
		let options = [];
		let { timezones } = this.props;
		timezones.forEach(timezone => {
			options.push({ key: timezone.id, value: timezone.id, label: timezone.name });
		});
		return (
			<div className="picker-input">{options.length > 0 && <SelectInput {...this.props} values={options} />}</div>
		);
	}
}

TimezonePicker.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	placeholder: PropTypes.string,
	tagInstructions: PropTypes.string,
	timezones: PropTypes.array,
	isRequired: PropTypes.bool,
};

const mapStateToProps = state => ({
	timezones: state.controlPanel.timezones,
});

export default connect(mapStateToProps)(TimezonePicker);
